import Api from '@/helpers/api';
/**
 * Obtiene la lista de empresas
 *
 * @returns {Promise<Company>} Promise - una promesa con la lista de empresas // Error
 */
const getAllCompanies = async () => {
    const result = await Api.get('/companies');
    return result.data;
};

/**
 * Obtiene una empresa, por su ID.
 *
 * @param {string} id - el Id de la empresa
 * @returns {Promise<Company>} Promise una promesa con el estado del servicio // Error
 */
const getOneCompany = async (id) => {
    const result = await Api.get(`/companies/${id}`);
    return result.data;
};

/**
 * Guarda una empresa
 *
 * @param {object} company - un objeto con los datos de la empresa a guardar
 * @returns {Promise<Company>} Promise - una promesa con el estado del servicio // Error
 */
const saveCompany = async (company) => {
    const result = await Api.post('/companies', company);
    return result.data;
};

/**
 * Actualiza una empresa
 *
 * @param {string} id - el Id de la empresa
 * @param {object} company - un objeto con los datos de la empresa a actualizar
 * @returns {Promise<Company>} Promise - una promesa con el estado del servicio // Error
 */
const updateCompany = async (id, company) => {
    const result = await Api.put(`/companies/${id}`, company);
    return result.data;
};

/**
 * Elimina una empresa
 *
 * @param {string} id - el Id de la empresa
 * @returns {Promise<Company>} Promise - una promesa con el estado del servicio // Error
 */
const deleteCompany = async (id) => {
    const result = await Api.delete(`/companies/${id}`);
    return result.data;
};


export {
    getAllCompanies,
    getOneCompany,
    saveCompany,
    updateCompany,
    deleteCompany
};
